import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "@/common/components/Entity/components/BaseEntityAutocompleteOrCreate";
import { VehicleDto } from "@/core/api/generated/v1";

import VehicleAutocomplete, { VehicleAutocompleteProps } from "./VehicleAutocomplete";
import VehicleCreateUpdate, { VehicleCreateUpdateProps } from "./VehicleCreateUpdate";
import VehicleCreateUpdateModal from "./VehicleCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  VehicleDto,
  VehicleCreateUpdateProps["defaultValues"],
  VehicleAutocompleteProps,
  VehicleCreateUpdateProps
>;

export default function VehicleAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      VehicleDto,
      VehicleCreateUpdateProps["defaultValues"],
      VehicleAutocompleteProps,
      VehicleCreateUpdateProps
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <VehicleAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new vehicle "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              plateNo: newOption?.inputValue
                ? {
                    plateNo: newOption?.inputValue,
                  }
                : undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <VehicleCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <VehicleCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
